function bindMouseOverToMegaMenu(item) {
  let openTimeout;
  let closeTimeout;

  item.addEventListener("mouseover", () => {
    // Clear any existing close timeout
    clearTimeout(closeTimeout);

    // Set a timeout to open the menu after a delay
    openTimeout = setTimeout(() => {
      item.setAttribute("open", true);
    }, 100); // Adjust the delay (in milliseconds) as needed

    // Prevent opening if moving to the mega menu content
    item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
      clearTimeout(openTimeout); // Clear the open timeout if hovering over the content
      item.setAttribute("open", true);
    });

    item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
      // Set a timeout to close the menu after a delay
      closeTimeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 100); // Adjust the delay (in milliseconds) as needed
    });
  });

  item.addEventListener("mouseleave", () => {
    // Clear the open timeout if the mouse leaves the item
    clearTimeout(openTimeout);
    
    // Set a timeout to close the menu after a delay
    closeTimeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 100); // Adjust the delay (in milliseconds) as needed
  });
}

let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu");
items.forEach(bindMouseOverToMegaMenu);
